import { MiniCompany } from "../types/company";

export function companySearchText(company: MiniCompany) {
  return `${company.name} ${company.brandNames.join(" ")}`;
}
